
import React from 'react';
import './_index.scss';

export default class Pagination extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    static defaultProps = {
        maxButtonCount: 5,
        pageSize: 20,
        total: 0
    };

    range(startIndex, length) {
        let array = [];
        for (var i = 0; i < length; i++) {
            array.push(startIndex + i);
        }

        return array;
    }

    buildButtons(pageCount) {
        const { maxButtonCount, pageNum } = this.props;
        const buttonCount = Math.min(pageCount, maxButtonCount);
        const maxPageNum = pageCount - 1;
        if (buttonCount > pageCount) {
            return this.range(0, buttonCount);
        } else {
            const sideButtonCount = Math.floor(maxButtonCount / 2);
            const leftPageNum = pageNum - sideButtonCount;
            const rightPageNum = pageNum + sideButtonCount;
            if (leftPageNum < 0) {
                return this.range(0, buttonCount);
            } else if (rightPageNum > maxPageNum) {
                return this.range(maxPageNum - buttonCount + 1, buttonCount);
            }

            return this.range(pageNum - sideButtonCount, buttonCount);
        }
    }

    onChangeNum = (num) => {
        this.props.onChangeNum && this.props.onChangeNum(num);
    }

    render() {
        const { pageNum, pageSize, total } = this.props;
        const pageCount = Math.floor((total + pageSize - 1) / pageSize);
        if (pageCount <= 1) {
            return null;
        }
        const buttons = this.buildButtons(pageCount);
        const numButtons = buttons.map(btn => {
            const className = "pubhub-pagination-button pubhub-pagination-num"
                + (pageNum == btn ? " pubhub-pagination-butto-active" : "");
            const btnNum = btn + 1;
            return (
                <div key={btn} className={className} onClick={() => { this.onChangeNum(btn) }}>
                    {btnNum}
                </div>
            );
        });

        const leftText = "<";
        const rightText = ">";
        const leftBtnDisabled = pageNum == 0;
        const rightBtnDisabled = pageNum >= pageCount - 1
        const leftBtnClassName = leftBtnDisabled ? " pubhub-pagination-button-disabled" : "";
        const rightBtnClassName = rightBtnDisabled ? " pubhub-pagination-button-disabled" : "";
        const leftBtnOnClick = !leftBtnDisabled ? () => { this.onChangeNum(pageNum - 1) } : null;
        const rightBtnOnClick = !rightBtnDisabled ? () => { this.onChangeNum(pageNum + 1) } : null;

        return (
            <div className="pubhub-pagination">
                <div className={"pubhub-pagination-button pubhub-pagination-prev" + leftBtnClassName}
                    onClick={leftBtnOnClick}>
                    {leftText}
                </div>
                {numButtons}
                <div className={"pubhub-pagination-button pubhub-pagination-next" + rightBtnClassName}
                    onClick={rightBtnOnClick}>
                    {rightText}
                </div>
            </div>
        );
    }
}